import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfl_J3_FTX_FT } from "../../../modules/Beräkningsmoduler/BFL_J3_FTX_FT";

import TidsKanalEditor from "../Editors/TidsKanalEditor";
import { BFLType, ModuleTypeId } from "../../../types/DBTables";
import { useBflHandler } from "../../../modules/Beräkningsmoduler/bflHandler";
import { useEffect } from "react";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { WeekDayName } from "../../../types/module-type";
import notify from "devextreme/ui/notify";
import DriftOptimeringar from "./DriftOptimeringar";
import { Card } from "react-bootstrap";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleVentilationFTXochFT } from "../../../types/ModuleDatas";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFL_J3_FTX_FT = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();
  const bflHandler = useBflHandler();
  const bimHandler = roundHandler.getBimHandler();

  const moduleData: IModuleVentilationFTXochFT = module.data;
  const isFTX = module.moduleTypeId === ModuleTypeId.VentilationFTX;
  const frmTidsKanaler = formHook.watch("data.tidsKanaler");

  const formData: any = formHook.getValues();

  const bm = bfl_J3_FTX_FT().getResult(module, bimHandler, roundHandler, global.data as IGlobalData, formData);

  const funktionsKontroller = bm.funktionsKontroller;
  const driftOptimeringar = bm.driftOptimeringar;

  const setDaysFrom = (channelName: string, dayName: WeekDayName, appliesTo: WeekDayName[]) => {
    var data = formHook.getValues();
    var tidsKanaler = data.data.tidsKanaler;
    if (tidsKanaler) {
      const kanal = tidsKanaler[channelName];
      if (kanal) {
        const periods = kanal[dayName];
        if (periods) {
          appliesTo.forEach((wd) => {
            kanal[wd] = periods.slice();
          });
          formHook.setValue("data.tidsKanaler." + channelName, kanal);
        }
      }
    }
  };

  const setChannelFromRound = (channelName: string) => {
    const kanal = module.data.tidsKanaler[channelName];
    if (kanal) formHook.setValue("data.tidsKanaler." + channelName, kanal);
  };

  const tidsKanaler = [
    {
      channelPath: "data.tidsKanaler",
      fieldName: "ventilation",
      caption: "Ventilation",
      hasType: true,
      buttons: [
        { caption: "Hämta schema från ronderingen", callback: (dayName: WeekDayName) => setChannelFromRound("ventilation") },
        {
          caption: "Applicera detta dagsschema för måndag-fredag",
          callback: (dayName: WeekDayName) =>
            setDaysFrom("ventilation", dayName, [WeekDayName.monday, WeekDayName.tuesday, WeekDayName.wednesday, WeekDayName.thursday, WeekDayName.friday]),
        },
        {
          caption: "Applicera detta dagsschema för lördag-söndag",
          callback: (dayName: WeekDayName) => setDaysFrom("ventilation", dayName, [WeekDayName.saturday, WeekDayName.sunday]),
        },
        {
          caption: "Applicera detta dagsschema för måndag-söndag",
          callback: (dayName: WeekDayName) =>
            setDaysFrom("ventilation", dayName, [
              WeekDayName.monday,
              WeekDayName.tuesday,
              WeekDayName.wednesday,
              WeekDayName.thursday,
              WeekDayName.friday,
              WeekDayName.saturday,
              WeekDayName.sunday,
            ]),
        },
      ],
    },
    { channelPath: "data.roundTidsKanaler", fieldName: "närvaro", caption: "Närvaro enligt rondering", hasType: false, disabled: true },
    { channelPath: "data.roundTidsKanaler", fieldName: "ventilation", caption: "Ventilation enligt rondering", hasType: true, disabled: true },
  ];

  const systemText = global.beräkningsflikarText.beskr_BFL_J3_FTX_FT;

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFL_J3_FTX_FT" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          {moduleData.driftÅretRunt === "Nej" && (
            <TidsKanalEditor showSwitch={true} data={module.bfs.BFL_J3_FTX_FT} formHook={formHook} tidsKanaler={tidsKanaler}></TidsKanalEditor>
          )}

          <DriftOptimeringar bfName="BFL_J3_FTX_FT" formHook={formHook} driftOptimeringar={driftOptimeringar} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
      {/* <Card.Header>BFL J3 FT{isFTX ? "X" : ""}</Card.Header> */}
    </div>
  );
};

export default BFL_J3_FTX_FT;
